export default "__VITE_ASSET__41070860__"